import React from 'react';
import { LoadingIcon } from "../../../internal/icons2022/LoadingIcon";
import { ButtonDataTids } from "../Button";
import { styles } from "../Button.styles";
export var LoadingButtonIcon = function LoadingButtonIcon(_ref) {
  var size = _ref.size,
    _ref$isCentered = _ref.isCentered,
    isCentered = _ref$isCentered === void 0 ? true : _ref$isCentered;
  return /*#__PURE__*/(
    React.createElement("div", {
      "data-tid": ButtonDataTids.spinner,
      className: isCentered ? styles.loading() : undefined
    }, /*#__PURE__*/
    React.createElement(LoadingIcon, {
      size: size
    }))
  );
};